<template>
    <div class="page-wrapper">
        <div class="banner">
            <div class="welcome-text"></div>
            <button class="btn-login" v-if="!userId" @click="toLogin">立即登录选购</button>
            <div class="mall-slogan" v-else>
                <span class="text">潮流生活，精选好物</span>
            </div>
            
        </div>
        <div class="mall-main">
            <div class="mall-crumb">
                <span class="item">首页</span>
                <em class="gap">&gt;</em>
                <span class="item cur">商品列表</span>
            </div>
            <div class="no-data" v-if="tableData.length == 0">
                <div class="img-none"></div>
                <div class="no-data-tip">暂无商品, 敬请期待~</div>
            </div>
            <div class="table-wrap" v-if="tableData.length > 0">
                <div class="goods-item" v-for="list in tableData" :key="list.item_id" @click="toGoodsDetail(list)">
                    <div class="inner">
                        <div class="imgBox">
                            <el-image class="img" :src="list.mallItemFileUrl" fit="cover" ></el-image>
                        </div>
                        <div class="nameLine">
                            <div class="goodTitle intwoline">{{list.itemName}}</div>
                            <div class="brand">{{list.brandName}} </div>
                        </div>
                        <div class="price">￥{{list.price | price}}</div>
                        <div class="bottomLine">
                            <div class="left">款号：{{list.styleNumber}}</div>
                            <div class="left">库存：{{list.stock}}件</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cg-pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[8, 20, 40, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mallItemList, updateItemState,exportItemInfo, exportMallList } from '../../../api/dealer'
import { mapGetters } from 'vuex'
import { saveAs } from 'file-saver'
import moment from 'moment'
export default {
    data() {
        return {
            loading: false,
            searchWords: '',
            tableData: [],
            // 分页
            pageSize: 20,
            total: 0,
            currentPage: 1,
            mid: '',
        }
    },
    computed: {
        ...mapGetters(['userId'])
    },
    watch: {
        '$route': {
            handler: function (route) {
                this.pageSize = Number(this.$route.query.size) ? Number(this.$route.query.size) : 20
                this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                this.searchWords = this.$route.query.search || ''
                this.mid = this.$route.query.mid || ''
                this.mallItemList();
            },
            immediate: true
        }
    },
    methods: {
        toLogin() {
            if (!this.userId) {
                this.$router.push('/login?redirect=' + this.$route.fullPath)
            }
        },
        exportMallList() {
            exportMallList({
                user_id: '',
                user_token: '',
                image_type: 12104,  // 12104 - 缩略图   12101 - 原图
                item_state: 1,

            }).then(res => {
                console.log(res)
                if (res.error_code == 0) {
                    this.$message.success('成功获取下载链接！')
                    saveAs(res.data.file, `zciiss数字云仓_商城商品_${moment().format("YYYY年MM月DD日HH时mm分")}`);
                    // window.location.href=res.data.file;
                } else {
                    this.$message.error(res.error_msg || '下载失败！')
                }
            }).catch(err => {
                console.log(err)
            })
        },
        mallItemList() {
            this.loading = true
            mallItemList({
                fuzzyQuery: this.searchWords,
                page: this.currentPage,
                num: this.pageSize,
                defaultValue: '1',  // defaultValue 这个字段是为了与 衣加加APP中的云仓商品列表作区分
                userId: this.mid || ''
            }).then(res => {
                this.loading = false
                console.log('mallItemList-res', res)
                if (res.errorCode == 200) {
                    this.tableData = res.data.mallItemList.map(item => {
                        return {
                            ...item,
                            mallItemFileUrl: process.env.VUE_APP_IMG_PREV + item.mallItemFileUrl
                        }
                    })
                    this.total = parseInt(res.data.totalCount)
                } else if (res.errorCode == -10111) {
                    // 暂无商品列表
                    this.tableData = []
                    this.total = 0
                    this.$message.error(res.errorMsg || '暂无商品列表')
                } else {
                    this.$message.error(res.errorMsg || '获取列表数据失败')
                }
            }).catch(err=> {
                this.loading = false
                console.log('mallItemList-err', err)
            })
        },
        searchHandle() {
            this.currentPage = 1
            this.curRoutePush()
        },
        toGoodsDetail(row) {
            console.log(row);
            this.$router.push('/dealer/goods/detail?id=' + row.item_id)
        },
        indexMethod(index) {
            return this.total - this.pageSize * (this.currentPage-1) - index;
        },
        handleSizeChange(val) {
            console.log(val)
            console.log(`每页 ${val} 条`);
            this.pageSize = val
            this.currentPage = 1
            this.curRoutePush()
        },
        curRoutePush() {
            this.$router.push('/dealer/index?mid='+ this.mid + '&search=' + this.searchWords + 
            '&page=' + this.currentPage + 
            '&size=' + this.pageSize).catch(err => {err})
        },
        handleCurrentChange(val) {
            console.log(val)
            console.log(`当前页: ${val}`);
            this.currentPage = val
            this.curRoutePush()
        },
    },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .banner {
        height: 500px;
        background: #f0f0f0 url(../../../assets/mall-index-banner.jpg) no-repeat;
        background-size: cover;
        overflow: hidden;
        .welcome-text {
            margin: 170px auto 0;
            width: 648px;
            height: 60px;
            background: url(../../../assets/welcome-word.png) no-repeat;
            background-size: 100% 100%;
        }
        .btn-login {
            outline: none;
            margin: 60px auto 0;
            display: block;
            width: 220px;
            height: 48px;
            background: #FF0E0E;
            border: none;
            font-size: 16px;
            color: #FFFFFF;
            letter-spacing: 1px;
        }
        .mall-slogan {
            margin: 40px 0 0;
            text-align: center;
            
            .text {
              
                padding: 6px 10px;
                
                font-size: 32px;
                color: #FFFFFF;
                letter-spacing: 1px;
            }
        }
    }
}
.mall-crumb {
    margin-top: 24px;
    padding: 10px 0;
    line-height: 22px;
    .item {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        &.cur {
            color: rgba(0, 0, 0, 0.65);
        }
    }
    .gap {
        font-weight: normal;
        font-size: 14px;
        margin:0 8px;
        color: rgba(0, 0, 0, 0.45);
        transform: scale(1, 1.4);
        display: inline-block;
    }
}


.mall-main {
    margin: 0 auto;
    width: 1132px;
    padding-bottom: 20px;
}
.table-wrap {
    margin: 0 -10px;
    background: #fff;
}

.goods-item{
    width: 25%; display: inline-block; box-sizing: border-box; padding: 20px 10px;
    .inner {
        border:1px solid #efefef; 
        &:hover {
            box-shadow: 0 0px 20px #ddd;
        }
    }
    .imgBox{
        height:280px; cursor: pointer;
        .img{width:100%; height: 280px;}
    }
    .nameLine{
        height: 60px;
       .goodTitle{color:#2A2E3F;font-size: 16px;margin:16px;line-height: 20px; width: 210px;margin-bottom:0px;
           max-height: 40px; cursor: pointer;
       } 
       .brand{color:#666666;font-size: 12px;padding-left:16px;}
    }
    .price{color:#E11010;font-size: 24px;padding-left:16px;}
    .bottomLine{
        padding:0 16px 10px;color:#666666;font-size: 12px;
    }
}
.titleLine{display: flex;
    .left{flex:1;color:#333;font-size: 30px;font-weight: bold;}
    .right{flex:1;text-align: right;}
}
.no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px 0 120px;
    .img-none {
        width: 240px;
        height: 126px;
        background: url(../../../assets/img_no_login.png) no-repeat;
        background-size: cover;
    }
    .no-data-tip {
        margin-top: 20px;
        font-size: 16px;
        color: #333;
        line-height: 32px;
    }
}
</style>